module.exports = __webpack_public_path__ + "static/media/trapezius_right_weak.c5987e13.png";